var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestCloudTunnelDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7.54659C2 4.48329 4.48329 2 7.54659 2C10.6099 2 13.0932 4.48329 13.0932 7.54659V11.6711L10.7288 9.29582V7.06464C10.7288 5.28785 9.28841 3.84747 7.51161 3.84747C5.77495 3.84747 4.35175 5.22578 4.29609 6.96154L4.22133 9.29307L2 11.6073V7.54659ZM7.54659 0C3.37872 0 0 3.37872 0 7.54659V13.8475C0 14.8373 1.20611 15.3225 1.89156 14.6084L5.70625 10.6342H6.54656V10.8211C6.54656 11.3734 6.99427 11.8211 7.54656 11.8211C8.09884 11.8211 8.54656 11.3734 8.54656 10.8211V10.6342H9.23911L13.2155 14.6289C13.907 15.3236 15.0932 14.8339 15.0932 13.8537V7.54659C15.0932 3.37872 11.7145 0 7.54659 0ZM8.72878 9.13423V7.06464C8.72878 6.39242 8.18384 5.84747 7.51161 5.84747C6.85457 5.84747 6.31612 6.36893 6.29506 7.02564L6.22745 9.13423H8.72878ZM7.54656 12.3422C8.09884 12.3422 8.54656 12.7899 8.54656 13.3422V14.0926C8.54656 14.6449 8.09884 15.0926 7.54656 15.0926C6.99427 15.0926 6.54656 14.6449 6.54656 14.0926V13.3422C6.54656 12.7899 6.99427 12.3422 7.54656 12.3422Z",
    fill: "#1D3066"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestCloudTunnelDefault);
export default __webpack_public_path__ + "static/media/test-cloud-tunnel-default.bde0568b5d046f8ae803d85c124660d5.svg";
export { ForwardRef as ReactComponent };